import {
  Add,
  CheckCircleOutline,
  MoreVert,
  NotInterested
} from '@mui/icons-material';
import {
  Avatar,
  Button,
  Grid,
  IconButton,
  InputBase,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Skeleton,
  SvgIcon,
  Tab,
  Tabs,
  Tooltip,
  Typography
} from '@mui/material';
import {
  colorLightYellow,
  colorPrimary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import { useNavigate } from 'react-router-dom';
import { Container } from '../../utils/styledLayout';
import { useDispatch, useSelector } from 'react-redux';
import { createTitle, handleError, isArrayNotEmpty } from '../../utils/utils';
import {
  activateDeactivateSchool,
  deleteSchool,
  getSchools,
  getSchoolsCount,
  revertSchoolPageData
} from '../../redux/reducers/mastersSlice';
import _ from 'lodash';
import CustomDataTable from '../../components/CustomDataTable';
import { useEffect, useState } from 'react';
import ConfirmBox from '../../components/ConfirmBox';
import moment from 'moment';
import SnackBarBox from '../../components/SnackBarBox';
import SearchInput from '../../components/SearchInput';
import { setActiveModule } from '../../redux/reducers/layoutSlice';
import { AddUserIcon, EditIcon, TrashIcon } from '../../utils/iconSvg';
import CustomTabLabel from '../../custom/CustomTabLabel';
let searchValue = '';

const SchoolPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { modules, isModulesSuccess } = useSelector(state => state.layout);
  const {
    isSchoolsLoading,
    schoolsData,
    isSchoolsFailed,
    schoolErrorContainer,
    isActivateDeactivateSchoolLoading,
    isActivateDeactivateSchoolSuccess,
    isActivateDeactivateSchoolFailed,
    activateDeactivateSchoolErrorContainer,
    activateDeactivateSchoolResponse,
    isDeleteSchoolSuccess,
    isDeleteSchoolFailed,
    isDeleteSchoolLoading,
    deleteSchoolErrorContainer
  } = useSelector(state => state.masters);
  const [initialValues, setInitalValues] = useState({
    tabValue: 0,
    page: 0,
    size: 10,
    searchFilter: ''
  });
  const { authData } = useSelector(state => state.auth);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [confirmation, setConfimation] = useState(null);
  const [showError, setShowError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    document.title = createTitle('Schools');
    dispatch(setActiveModule('Schools'));
    dispatch(getSchoolsCount());
    return () => {
      dispatch(revertSchoolPageData());
    };
  }, []);

  useEffect(() => {
    dispatch(
      getSchools({
        type:
          initialValues.tabValue === 1
            ? true
            : initialValues.tabValue === 2
              ? false
              : 'all',
        page: initialValues.page,
        size: initialValues.size,
        searchFilter: initialValues.searchFilter
      })
    );
  }, [initialValues]);

  const debouncedSearch = _.debounce(
    term => setInitalValues({ ...initialValues, searchFilter: term, page: 0 }),
    300
  );

  const handleSearchChange = e => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  const handleMenuActions = action => {
    setShowError(null);
    if (action === 'Delete') {
      handleDeleteArea();
    } else if (action === 'De-Activate') {
      handleDeActivateArea();
    } else if (action === 'Activate') {
      handleActivateArea();
    }
  };

  const handleDeleteArea = () => {
    let errorMessage = '';
    if (isArrayNotEmpty(schoolsData?.schools)) {
      if (isArrayNotEmpty(selectedAreas)) {
        setConfimation(true);
      } else {
        errorMessage = 'Please select school[s] to delete.';
      }
    }
    setShowError(errorMessage);
  };

  const handleActivateArea = () => {
    let errorMessage = '';
    if (isArrayNotEmpty(schoolsData.schools)) {
      if (!isArrayNotEmpty(selectedAreas)) {
        errorMessage = 'Please select school[s] to activate.';
      } else {
        const selectedUsersData = schoolsData.schools.filter(user =>
          selectedAreas.includes(user.schoolId)
        );
        const allUsersActive = selectedUsersData.every(user => !user.status);
        if (!allUsersActive) {
          errorMessage = 'Please select only inactive school[s] to activate.';
        } else {
          let payload = {
            isActivate: true,
            ids: [...selectedAreas],
            loggedInUserName: authData?.userName
          };
          dispatch(activateDeactivateSchool(payload));
        }
      }
    }
    setShowError(errorMessage);
  };

  useEffect(() => {
    if (isActivateDeactivateSchoolSuccess || isDeleteSchoolSuccess) {
      return handleReset();
    }
  }, [isActivateDeactivateSchoolSuccess, isDeleteSchoolSuccess]);

  const handleDeActivateArea = () => {
    let errorMessage = '';
    if (isArrayNotEmpty(schoolsData?.schools)) {
      if (!isArrayNotEmpty(selectedAreas)) {
        errorMessage = 'Please select school[s] to in-activate.';
      } else {
        const selectedUsersData = schoolsData.schools.filter(user =>
          selectedAreas.includes(user.schoolId)
        );
        const allUsersActive = selectedUsersData.every(user => user.status);
        if (!allUsersActive) {
          errorMessage = 'Please select only active school[s] to in-activate.';
        } else {
          let payload = {
            isActivate: false,
            ids: [...selectedAreas],
            loggedInUserName: authData?.userName
          };

          dispatch(activateDeactivateSchool(payload));
        }
      }
    }
    setShowError(errorMessage);
  };

  const deleteUser = () => {
    let deletePayload = {
      ids: [...selectedAreas],
      loggedInUserName: authData?.userName
    };
    dispatch(deleteSchool(deletePayload));
  };

  const handleReset = () => {
    setSelectedAreas([]);
    setShowError(null);
    setConfimation(null);
    setInitalValues({ tabValue: 0, page: 0, size: 10, searchFilter: '' });
    setAnchorEl(null);
    dispatch(getSchoolsCount());
  };

  useEffect(() => {
    if (
      isActivateDeactivateSchoolSuccess ||
      isDeleteSchoolSuccess ||
      isActivateDeactivateSchoolSuccess
    ) {
      return handleReset();
    }
  }, [
    isActivateDeactivateSchoolSuccess,
    isDeleteSchoolSuccess,
    isActivateDeactivateSchoolSuccess
  ]);

  const handleSchoolEditNavigation = schoolId => {
    navigate('school-details/edit-school', {
      state: {
        ...location.state,
        schoolId: schoolId
      }
    });
  };

  const columns = [
    {
      uinqueKey: 'schoolId',
      id: 'schoolName',
      label: 'School',
      sortable: true,
      width: '150px'
      // render: row => {
      //   return (
      //     <a
      //       style={{
      //         textDecoration: 'underline',
      //         textUnderlineOffset: '3px'
      //       }}
      //       onClick={() => {

      //       }}
      //     >
      //       <Typography variant="body2" fontWeight={'600'}>
      //         {row.schoolName}
      //       </Typography>
      //     </a>
      //   );
      // }
    },
    {
      id: 'area',
      label: 'Area',
      sortable: true
    },
    {
      id: 'districtName',
      label: 'District ',
      sortable: true,
      render: row => {
        return (
          <Typography variant="body2" fontWeight={'600'}>
            {/* {row.districtCode ? `(${row.districtCode})` : ''}  */}
            {row.districtName}
          </Typography>
        );
      }
    },
    {
      id: 'stateName',
      label: 'State ',
      sortable: true,
      render: row => {
        return (
          <Typography variant="body2" fontWeight={'600'}>
            {/* {row.stateCode ? `(${row.stateCode})` : ''}  */}
            {row.stateName}
          </Typography>
        );
      }
    },
    {
      id: 'users',
      label: 'Users',
      sortable: true
    },
    {
      id: 'status',
      label: 'Status',
      width: '150px',
      render: row => (
        <>
          <div
            style={{
              fontWeight: '600',
              fontSize: 12,
              backgroundColor: row.status ? '#EBF9D9' : '#FDF0E3',
              padding: '4px 8px 4px 8px',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: row.status ? '#749E35' : '#D62828',
              width: row.status ? '62px' : '70px',
              height: '22px'
            }}
          >
            <Avatar
              sx={{
                width: 8,
                height: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: row.status ? '#749E35' : '#D62828',
                color: 'white',
                fontSize: '12px',
                marginRight: '5px'
              }}
            >
              <></>
            </Avatar>
            {row.status ? 'Active' : 'Inactive'}
          </div>
        </>
      )
    },
    {
      id: 'createdBy',
      label: 'Created By'
    },
    {
      id: 'creationDate',
      label: 'Created On',
      width: '150px',
      render: row => {
        return (
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography fontSize={'14px'} fontWeight={'600'}>
                {row.creationDate
                  ? moment(row.creationDate).format('DD-MM-YYYY hh:mm A')
                  : 'NA'}
              </Typography>
            </div>
          </>
        );
      }
    },
    {
      id: 'edit',
      label: '',
      width: '50px',
      render: row => {
        return (
          <IconButton
            size="small"
            onClick={e => {
              handleSchoolEditNavigation(row.schoolId);
              e.stopPropagation();
            }}
          >
            <EditIcon />
          </IconButton>
        );
      }
    }
  ];

  const handleOnRowClick = row => {
    return navigate(`school-details`, {
      state: { schoolId: row.schoolId }
    });
  };

  return (
    <>
      <Container mb={1}>
        <Grid>
          <Typography fontSize={32} fontWeight="700" display={'flex'}>
            Schools
            {/* <Typography
              ml={1}
              fontSize={20}
              fontWeight="700"
              alignSelf={'center'}
            >
              ({schoolsData?.totalCount})
            </Typography>{' '} */}
          </Typography>
        </Grid>

        <Grid>
          <Button
            sx={{
              boxShadow: 'none'
            }}
            variant="contained"
            onClick={() => {
              navigate('new-school');
            }}
          >
            <SvgIcon
              fontSize="small"
              sx={{ marginRight: 0.8, height: '16px', width: '16px' }}
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                  stroke={colorTextBlack}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>
            Add new
          </Button>
        </Grid>
      </Container>
      <Grid
        container
        display={'flex'}
        flexDirection={'column'}
        elevation={0}
        component={Paper}
        borderRadius={'8px'}
        sx={{ paddingX: '14px', pt: 1 }}
      >
        <Container
          sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }}
        >
          <Tabs
            value={initialValues.tabValue}
            onChange={(val, newValue) => {
              setInitalValues({
                ...initialValues,
                tabValue: newValue,
                page: 0
              });
              setSelectedAreas([]);
            }}
            TabIndicatorProps={{
              sx: {
                height: '4px',
                borderRadius: '4px'
              }
            }}
          >
            <Tab
              sx={{
                minHeight: 44,
                height: 44,
                fontSize: '16px',
                color: colorTextGrey,
                fontWeight: initialValues.tabValue === 0 ? '700' : '600',
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 0
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              iconPosition="start"
              label={
                <CustomTabLabel
                  title="All Schools "
                  count={
                    schoolsData?.allCount < 10
                      ? `0${schoolsData?.allCount}`
                      : schoolsData?.allCount
                  }
                  selected={initialValues.tabValue === 0}
                />
              }
            />
            <Tab
              sx={{
                minHeight: 44,
                height: 44,
                fontSize: '16px',
                color: colorTextGrey,
                fontWeight: initialValues.tabValue === 1 ? '700' : '600',
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 1
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              iconPosition="start"
              label={
                <CustomTabLabel
                  title="Active Schools"
                  count={
                    schoolsData?.activeCount < 10
                      ? `0${schoolsData?.activeCount}`
                      : schoolsData?.activeCount
                  }
                  selected={initialValues.tabValue === 1}
                />
              }
            />
            <Tab
              sx={{
                minHeight: 44,
                height: 44,
                fontSize: '16px',
                color: colorTextGrey,
                fontWeight: initialValues.tabValue === 2 ? '700' : '600',
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 2
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              iconPosition="start"
              label={
                <CustomTabLabel
                  title="Inactive Schools"
                  count={
                    schoolsData?.inActiveCount < 10
                      ? `0${schoolsData?.inActiveCount}`
                      : schoolsData?.inActiveCount
                  }
                  selected={initialValues.tabValue === 2}
                />
              }
            />
          </Tabs>
          <div style={{ display: 'flex', margin: 'auto 10px' }}>
            <SearchInput
              onSearchChange={handleSearchChange}
              searchTerm={searchTerm}
            />
            <Tooltip title="More options">
              {' '}
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={event => setAnchorEl(event.currentTarget)}
              >
                <MoreVert />
              </IconButton>
            </Tooltip>

            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={() => {
                setAnchorEl(null);
                setShowError(null);
              }}
              PaperProps={{
                elevation: 0,
                sx: {
                  width: '20ch',
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                  },
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0
                  }
                }
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {['Activate', 'De-Activate', 'Delete'].map(option => (
                <MenuItem
                  key={option}
                  disabled={
                    (initialValues.tabValue === 1 && option === 'Activate') ||
                    (initialValues.tabValue === 2 && option === 'De-Activate')
                  }
                  onClick={() => {
                    handleMenuActions(option);
                  }}
                >
                  <ListItemIcon>
                    {option === 'Delete' ? (
                      <>
                        <SvgIcon sx={{ height: 20, width: 20 }}>
                          <TrashIcon color="red" />
                        </SvgIcon>
                      </>
                    ) : option === 'De-Activate' ? (
                      <SvgIcon
                        sx={{ height: 20, width: 20, color: 'orangered' }}
                      >
                        <NotInterested />
                      </SvgIcon>
                    ) : option === 'Activate' ? (
                      <SvgIcon sx={{ height: 20, width: 20, color: 'green' }}>
                        <CheckCircleOutline />
                      </SvgIcon>
                    ) : (
                      ''
                    )}
                  </ListItemIcon>
                  {option}
                </MenuItem>
              ))}
            </Menu>
          </div>
        </Container>
        <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
          {(isSchoolsLoading ||
            isActivateDeactivateSchoolLoading ||
            isDeleteSchoolLoading) && (
            <Skeleton
              variant="rounded"
              width={'100%'}
              height={400}
              animation="wave"
            />
          )}

          {!isSchoolsLoading &&
            !isActivateDeactivateSchoolLoading &&
            !isDeleteSchoolLoading && (
              <CustomDataTable
                columns={columns}
                allowSelection={true}
                data={
                  schoolsData?.schools?.length > 0 ? schoolsData?.schools : []
                }
                onPageChange={val => {
                  setInitalValues({ ...initialValues, page: val });
                }}
                onRowsPerPageChange={val => {
                  setInitalValues({ ...initialValues, size: val });
                }}
                selectedRows={[...selectedAreas]}
                onSelectionChange={val => {
                  setSelectedAreas(val);
                }}
                defaultOrderBy={'creationDate'}
                defaultPage={initialValues.page}
                defaultRowsPerPage={initialValues.size}
                totalCount={schoolsData?.totalCount}
                onRowClick={row => handleOnRowClick(row)}
              />
            )}
        </Grid>

        <ConfirmBox
          isOpen={confirmation}
          title="Delete School!"
          subtitle={`${selectedAreas.length} school[s] are selected, Are you sure you want to delete. `}
          handleClose={() => setConfimation(null)}
          handleSubmit={() => {
            deleteUser();
          }}
        />

        {showError && <SnackBarBox type={'error'} message={showError} />}

        {!isSchoolsLoading && isSchoolsFailed && (
          <SnackBarBox
            type="error"
            message={handleError(schoolErrorContainer?.errorMessage)}
          />
        )}

        {!isDeleteSchoolLoading && isDeleteSchoolSuccess && (
          <SnackBarBox
            type="success"
            message={'schools[s] deleted successfully. '}
          />
        )}

        {!isDeleteSchoolLoading && isDeleteSchoolFailed && (
          <SnackBarBox
            type="error"
            message={handleError(deleteSchoolErrorContainer?.errorMessage)}
          />
        )}

        {!isActivateDeactivateSchoolLoading &&
          isActivateDeactivateSchoolSuccess && (
            <SnackBarBox
              type="success"
              message={activateDeactivateSchoolResponse}
            />
          )}

        {!isActivateDeactivateSchoolLoading &&
          isActivateDeactivateSchoolFailed && (
            <SnackBarBox
              type="error"
              message={handleError(
                activateDeactivateSchoolErrorContainer?.errorMessage
              )}
            />
          )}
      </Grid>
    </>
  );
};

export default SchoolPage;
